<script setup>
import { onMounted, ref } from "vue"
import api from "@/api/axios.js"

const citas = ref([])
const cargando = ref(true)

async function cargar() {
  cargando.value = true
  try {
    const { data } = await api.get("/citas/mis-proximas")
    citas.value = data.citas
  } catch (err) {
    console.error(err)
  } finally {
    cargando.value = false
  }
}

onMounted(cargar)

function formatFecha(value) {
  if (!value) return ""
  return new Date(value).toLocaleDateString("es-CO", { timeZone: "UTC", year: "numeric", month: "2-digit", day: "2-digit" })
}
</script>

<template>
  <div class="card">
    <div class="p-3 pb-0 card-header">
      <h6 class="mb-2"><i class="ni ni-calendar-grid-58 text-primary me-1"></i>Mis próximas citas</h6>
    </div>
    <div class="card-body pt-2">
      <div v-if="cargando" class="text-muted text-sm">Cargando...</div>
      <div v-else-if="citas.length === 0" class="text-muted text-sm">No tienes citas próximas.</div>
      <ul v-else class="list-group list-group-flush">
        <li v-for="c in citas" :key="c.id" class="list-group-item px-0 d-flex justify-content-between align-items-center">
          <div>
            <p class="mb-0 text-sm font-weight-bold">{{ c.nombreCliente }} — {{ c.celular }}</p>
            <p class="mb-0 text-xs text-muted">
              {{ formatFecha(c.fecha) }} · {{ c.horaInicio }} - {{ c.horaFin }}
              <span v-if="c.ciudadNombre"> · {{ c.ciudadNombre }}</span>
            </p>
            <a
              v-if="c.tipo === 'virtual' && c.linkReunion"
              :href="c.linkReunion" target="_blank" rel="noopener"
              class="text-xs"
            >
              <i class="bi bi-camera-video me-1"></i>Unirse por Google Meet
            </a>
          </div>
          <span class="badge" :class="c.estado === 'confirmada' ? 'bg-info' : 'bg-warning text-dark'">
            {{ c.estado === "confirmada" ? "Confirmada" : "Pendiente" }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>
